module.exports = __webpack_public_path__ + "img/back1.43d60058.jpg";